import MongoDB from "../../../../contents/docs/cdp/sources/_snippets/source-mongodb.mdx";
import * as React from 'react';
export default {
  MongoDB,
  React
};